import {getValidationErrors} from "../helpers/tools";
import classNames from "classnames";

export default {
  props: {
    errors: Object,
    name: {
      type: String,
      required: true,
    },
    renderComponent: {
      type: Function,
      required: true,
    },
    activeClassname: {
      type: String,
      default: "border-red-500"
    },
    inactiveClassname: {
      type: String,
      default: "border-faded-200"
    },
    classname: String,
  },

  watch: {
    errors(nextVal, val) {
      const keys = Object.keys(nextVal);
      if(keys.length > 0) {
        this.$nextTick(() => {
          Array.from(
            document.getElementsByTagName("form")
          ).forEach(form => {
            const all = form.querySelectorAll(".js-validated-component");
            if(all.length > 0) {
              all[0].scrollIntoView({ behavior: "smooth", block: "center" });
            }
          });
        })
      }
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const errors = getValidationErrors(this.errors, this.name);
    const childClassname = errors
      ? classNames(this.activeClassname, "js-validated-component")
      : this.inactiveClassname;
    const child = this.renderComponent(classNames(this.classname, childClassname));

    return (
      <fragment>
        {child}
        {errors && (
          <p class="text-xs py-1 text-red-500 italic">
            {errors}
          </p>
        )}
      </fragment>
    )
  }
}